import { render, staticRenderFns } from "./avatar-dropdown.vue?vue&type=template&id=bd53da4a&"
import script from "./avatar-dropdown.vue?vue&type=script&lang=js&"
export * from "./avatar-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./avatar-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports